<app-nav></app-nav>
<div class="container">
  <div class="row justify-content-center align-items-center mt-4">
    <form class="col-12">
      <div class="form-group">
        <div class="col notes-heading">
          <h3 style="padding-left: 12px;">Your Bookmarks</h3>
        </div>
        <mat-progress-bar
          class="mb-2"
          mode="indeterminate"
          style="margin-top: -2rem;"
          *ngIf="isLoading"
        ></mat-progress-bar>
        <div class="row">
          <div class="col">
            <label for="projects" class="float-label"
              >Move selected bookmarks to project</label
            >
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
            <select
              class="form-control"
              [(ngModel)]="selectedLinkId"
              name="links"
              id="projects"
            >
              <option *ngFor="let note of notes" [value]="note.id">{{
                note.title
              }}</option>
            </select>
          </div>
          <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
            <button
              type="button"
              class="btn btn-primary"
              (click)="moveLinks()"
              [disabled]="!getIfSelected()"
            >
              Assign
            </button>
            <button
              class="btn btn-icon btn-3 btn-outline-primary"
              (click)="lgModal.show()"
              type="button"
            >
              <span class="btn-inner--icon"
                ><i class="fa fa-folder-plus"></i
              ></span>
              <!-- <span class="btn-inner--text">New</span> -->
            </button>
            
          </div>
        </div>
        <div class="row">
          <div class="col viewer">
            <!-- References Component -->
            <app-references
            [showPinned]="false"
            [isProjectPage]="false"
            [columnsCount]=3
            (linkSelected)="linkSelectChanged($event)"
            ></app-references>
            <!-- References Component -->
          
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Modal -->
<div
  bsModal
  #lgModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-sizes-name1"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <h4 id="dialog-sizes-name1" class="modal-title pull-left">Large modal</h4> -->
        <button
          type="button"
          class="close pull-right"
          (click)="lgModal.hide()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container h-100">
          <div class="row h-100 justify-content-center align-items-center">
            <form class="col-12">
              <div class="form-group">
                <h3 for="projectName">
                  What do you want to call your new project?
                </h3>
                <input
                  type="text"
                  class="form-control"
                  id="projectName"
                  placeholder="Project Name"
                  [(ngModel)]="projectName"
                  name="name"
                />
              </div>
              <button
                type="button"
                class="btn btn-primary float-right"
                (click)="createProject()"
              >
                Create
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Page viewer Overlay -->
<div
  bsModal
  #contentModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-sizes-name1"
>
  
  <div class="modal-dialog modal-lg" style="max-width: 100vw !important;width: 100vw !important; ">
    <div class="modal-content" style="overflow-y: scroll;">
      <div class="modal-header">
        <!-- <h4 id="dialog-sizes-name1" class="modal-title pull-left">Large modal</h4> -->
        <button
          type="button"
          class="close pull-right"
          (click)="contentModal.hide()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container h-100">
          
          <p [innerHtml]="contentToView"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Page Viewer Overlay -->
